"use client";

import { JumpMenuContext } from "@/providers/jump-menu.provider";
import React, { useContext, useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";

type Props = {
  children: React.ReactNode;
  id: string;
  name: string;
};

const JumpMenuAnchorObserver = ({ children, id, name }: Props) => {
  const { updateAnchor, addAnchor, removeAnchor } = useContext(JumpMenuContext);
  const anchorRef = useRef<HTMLDivElement | null>(null);
  const Y_OFFSET = 100;

  const { ref, inView, entry } = useInView({
    rootMargin: "-45% 0px -45% 0px",
    onChange: (viewState, entry) => {
      if (viewState !== inView) updateAnchor(id, viewState);
    },
  });

  useEffect(() => {
    const anchorPosition = anchorRef.current?.getBoundingClientRect().top! + window.scrollY;
    const screenCenter = window.innerHeight / 2;
    const position = anchorPosition - Y_OFFSET;

    addAnchor(id, name, position);
    return () => {
      removeAnchor(id);
    };
  }, [addAnchor, id, name, removeAnchor]);

  useEffect(() => {
    if (anchorRef.current) {
      ref(anchorRef.current);
    }
  }, [ref]);

  return <div ref={anchorRef}>{children}</div>;
};

export default JumpMenuAnchorObserver;
